import { makeTranslationHelpers } from '@/hooks/useTranslation';

const {
  useTranslation: useOverviewTranslation,
  Translation: OverviewTranslation,
} = makeTranslationHelpers('page.companyReport.overview');

export { useOverviewTranslation, OverviewTranslation };
